// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_mi","wrapperDark":"e_ni","wrapperLight":"e_oi"};